import { YesNoCancelModal } from "%modals";

export default ({ checkChanges, onSave, onReject, onCancel }) => ({
  beforeRouteLeave(to, from, next) {
    if (checkChanges.bind(this)()) {
      this.$emit("show-modal", {
        component: YesNoCancelModal,
        props: {
          title: "Niezapisane zmiany",
          content: `
            <p>Wprowadzono zmiany, które nie zostały zapisane.</p>
            <p>Czy chcesz je zapisać przed wyjściem?</p>
          `,
          proceed: {
            type: "is-success",
            icon: "fa-check",
            content: "Zapisz",
            callback: async () => {
              onSave && (await onSave.bind(this)());
              next();
            }
          },

          reject: {
            type: "is-danger",
            icon: "fa-times",
            content: "Odrzuć",
            callback: async () => {
              onReject && (await onReject.bind(this)());
              next();
            }
          },

          cancel: {
            content: "Anuluj",
            callback: async () => {
              onCancel && (await onCancel.bind(this)());
              next(false);
            }
          }
        }
      });
    } else next();
  }
});
